/**
 * Base address of the PipeDrive workspace, without a trailing slash.
 *
 * Configured rather than hardcoded: the workspace host is deployment detail,
 * and a link to it appears on several screens — spelling it out in each one
 * would mean finding them all again the day the workspace moves.
 */
const WORKSPACE_URL = (import.meta.env.VITE_PIPEDRIVE_URL ?? 'https://skyrise.pipedrive.com').replace(
  /\/+$/,
  ''
);

/**
 * Link to a deal in PipeDrive, or undefined when there is no deal to link to.
 *
 * Returning undefined rather than a half-built address lets a caller render
 * plain text instead of a link that leads to the deal list — a link that looks
 * like it goes somewhere specific and does not is worse than no link.
 */
export const pipedriveDealUrl = (dealId?: number | string | null): string | undefined => {
  const id = typeof dealId === 'string' ? dealId.trim() : dealId;
  if (id === null || id === undefined || id === '') return undefined;
  return `${WORKSPACE_URL}/deal/${id}`;
};
